import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1248e285"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_DropdownMultiCheckbox = _resolveComponent("DropdownMultiCheckbox")!
  const _component_FilterBarDownload = _resolveComponent("FilterBarDownload")!

  return (_openBlock(), _createBlock(_component_FilterBarDownload, {
    "download-file-async": _ctx.downloadFileAsync,
    onToggle: _ctx.toggleModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Typography, { variant: "body1" }, {
        default: _withCtx(() => [
          _createTextVNode("We've summarized your key response data in a presentation ready for download.")
        ], undefined, true),
        _: 1
      }),
      _hoisted_1,
      _createVNode(_component_Typography, { variant: "body1" }, {
        default: _withCtx(() => [
          _createTextVNode("Your user role and current dashboard filters will both be applied to the data in the presentation.")
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_DropdownMultiCheckbox, {
        class: "leaderboard-select",
        options: _ctx.leaderboardList,
        values: _ctx.selectedLeaderboards,
        label: "Leaderboards",
        onChange: _ctx.onLeaderboardSelect
      }, null, 8, ["options", "values", "onChange"])
    ], undefined, true),
    _: 1
  }, 8, ["download-file-async", "onToggle"]))
}